import { formatDateTimeFrEpoch, formatDateToDDMMYYYYFrEpoch, newGUID } from "../../utils/util";
import crmservices from ".";

export const dataUtil = {
    getCurrentTier,
    getImageByUsageType,
    getProductImageByUsageType,
    getLCSName,
    getLineItems,
    groupedByCategory,
    getDeliveryItem,
    covertListToString,
    getProductPrice,
    validateFulfilment,
    getTotalCartQuantity,
    validateComponents,
    getTotalBaseItems,
    filterContactPreferencesByType,
    checkAllowPaymentMethod,
    checkAllowOrderByContact,
    groupedVariantByAttributes,
    findProductByVariantAttributes,
    getTotalPerProduct,
    getTotalAmountItem,
    sortByCardPrimary,
    createItemToReorder,
    getOrderSummary,
    getProductImageBySize,
    createEsitmateCartItems,
    getImageByUsageTypePortal,
    sortPrice,
    groupServicesByMonth,
    groupBillingPeriod,
    getRemainingService,
    getCartItemsValid,
    getImageByUsageTypeSmallSize,
    groupBillingPeriodv2,
    groupServicesByMonthv2,
    getOfferTypeProgress,
    compareMerchants,
    calculatePriceByRate,
    getBillingPeriod,
    compareMerchants,
    compareMerchants,

};
export const usage_type = {
    offers: 'AVATAR',
    offers_merchant: 'AVATAR',
    offer_detail: 'AVATAR',
    offer_detail_merchant: 'LOGO',
    offer_map: 'AVATAR',
    offer_map_merchant: 'AVATAR',
    offer_order: 'AVATAR',
    product_item: 'AVATAR',
    product_detail: 'AVATAR',
    refer_friend: 'MARKETING',
    catalog: 'AVATAR',
    business_logo: 'BUSINESS_APP_LOGO',
    wallet_image: "WALLET_IMAGE",
    landing_page_bg: "LANDING_PAGE_IMAGE",
    delivery_image: "DELIVERY_IMAGE",
    pickup_image: "PICKUP_IMAGE",
    direct_sale_image: "DIRECT_SALE_IMAGE",
    APP_LOGO: "APP_LOGO",
    merchants_image: 'AVATAR',
    carousel_image: 'CAROUSEL'
}

export const preferences_type = {
    order: "ORDERS",
    rewards: "REWARDS"
}

function getCurrentTier(reward_tier) {
    var period_value_units = reward_tier && reward_tier.period_value_units ? reward_tier.period_value_units : 0;
    var points_needed = reward_tier && reward_tier.maintain_tier && reward_tier.maintain_tier.points_needed ? reward_tier.maintain_tier.points_needed : 0;
    var collected_by = reward_tier && reward_tier.maintain_tier && reward_tier.maintain_tier.collected_by ? reward_tier.maintain_tier.collected_by : 0;
    var remain_name = reward_tier && reward_tier.name ? reward_tier.name : "";
    var progress = reward_tier && reward_tier.progress ? reward_tier.progress : null;
    var isProgress = false;
    if (progress) {
        points_needed = progress && progress.points_needed ? progress.points_needed : 0;
        collected_by = progress && progress.collected_by ? progress.collected_by : 0;
        remain_name = progress && progress.name ? progress.name : "";
        isProgress = true;
    }
    var percentage = (period_value_units * 100) / (points_needed + period_value_units);
    if (isNaN(percentage))
        percentage = 0
    return {
        current_name: reward_tier && reward_tier.name ? reward_tier.name : "",
        current_color: reward_tier && reward_tier.color ? reward_tier.color : "",
        period_value_units: period_value_units,
        collected_by: collected_by ? formatDateToDDMMYYYYFrEpoch(collected_by, true) : "",
        points_needed: points_needed,
        remain_name: remain_name,
        percentage: percentage ? Math.round(percentage) : percentage,
        isProgress: isProgress,
        tier_image: reward_tier.creatives ? reward_tier.creatives[0] : null,
    }
}


function getImageByUsageType(creatives, type, ignoreFirstElement) {
    let imageSources = [];
    let creative = null;
    if (!creatives || creatives.length == 0)
        return [];
    var isExitType = false;
    if (type) {
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === type.toLowerCase()) {
                creative = element;
                isExitType = true;
            }
        });
    }
    // if (!isExitType && !ignoreFirstElement) {
    //     creative = creatives[0];
    // }
    //console.log("AAAAAAAAAA creative = ", creative);
    if (creative) {
        let media = creative.media;
        if (media && media.length > 0) {
            media.forEach(m => {
                if (m.width > 50 && m.height > 50) {
                    imageSources.push({
                        uri: m.url,
                        width: m.width,
                        height: m.height
                    })
                }
            });
        } else {
            imageSources.push({
                uri: creative.url,
                width: creative.width,
                height: creative.height
            })
        }
    }
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA imageSources:",imageSources);
    return imageSources;
}

function getImageByUsageTypeSmallSize(creatives, type, ignoreFirstElement) {
    let imageSources = [];
    let creative = null;
    if (!creatives || creatives.length == 0)
        return [];
    var isExitType = false;
    if (type) {
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === type.toLowerCase()) {
                creative = element;
                isExitType = true;
            }
        });
    }
    // if (!isExitType && !ignoreFirstElement) {
    //     creative = creatives[0];
    // }
    //console.log("AAAAAAAAAA creative = ", creative);
    if (creative) {
        let media = creative.media;
        if (media && media.length > 0) {
            imageSources.push({
                uri: media[0].url,
                width: media[0].width,
                height: media[0].height
            })
        } else {
            imageSources.push({
                uri: creative.url,
                width: creative.width,
                height: creative.height
            })
        }
    }
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA imageSources:",imageSources);
    return imageSources;
}

function getImageByUsageTypePortal(creatives, type, ignoreFirstElement) {
    let imageSources = [];
    let creative = null;
    if (!creatives || creatives.length == 0)
        return [];
    var isExitType = false;
    if (type) {
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === type.toLowerCase()) {
                creative = element;
                isExitType = true;
            }
        });
    }
    if (!isExitType && !ignoreFirstElement) {
        creative = creatives[0];
    }
    if (creative) {
        let media = creative.media;
        if (media && media.length > 0) {
            media.forEach(m => {
                if (m.width > 50 && m.height > 50) {
                    imageSources.push({
                        url: m.url,
                        width: m.width,
                        height: m.height
                    })
                }
            });
        } else {
            imageSources.push({
                url: creative.url,
                width: creative.width,
                height: creative.height
            })
        }
    }
    return imageSources.length > 0 ? imageSources[0] : null;
}


function getProductImageByUsageType(creatives) {
    if (!creatives || creatives.length == 0)
        return null;
    var isExitType = false;
    var image = null;
    creatives.forEach(element => {
        if (element.usage_type && element.usage_type.toLowerCase() === usage_type.product_detail.toLowerCase()) {
            image = element;
            isExitType = true;
        }
    });
    if (!isExitType) {
        var isExitNextType = false;
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === usage_type.product_item.toLowerCase()) {
                image = element;
                isExitNextType = true;
            }
        });
        if (!isExitNextType) {
            image = creatives[0]
        }
    }
    if (image && image.url)
        return image;
    return null;
}

function getLCSName(code) {
    var name = code ? code : "";
    if (code === 'IN_PROGRESS')
        name = 'In Progress'
    else if (code === 'CANCELLED')
        name = 'Cancelled'
    else if (code === 'NEW')
        name = 'New'
    else if (code === 'COMPLETED')
        name = 'Completed'
    else if (code === 'CANCELLED')
        name = 'Cancelled'
    else if (code === 'PENDING')
        name = 'Pending'
    return name;
}

/////////////Order
function getLineItems(cart) {
    var lineItems = [];
    cart.forEach(element => {
        var item = {
            id: element.id,
            quantity: element.quantity,
            // price: element.price,
            tax_model: 'TAX_INCLUSIVE',
            notes: element.notes ? element.notes : null
        }
        var components = []
        if (element.components) {
            element.components.forEach(c => {
                var component = {
                    id: c.id,
                    quantity: c.quantity,
                    tax_model: 'TAX_INCLUSIVE'
                }
                if (element.price_selected && (element.classification == "TERMED_SERVICE" || element.classification == "ONE_TIME_SERVICE")) {
                    if (c.pricing && c.pricing.length > 0) {
                        component.price_terms_id = c.pricing[0].id;
                    }
                }
                components.push(component);
            });
        }
        if (components.length > 0) {
            item.components = components
        }
        if (element.price_selected && (element.classification == "TERMED_SERVICE" || element.classification == "ONE_TIME_SERVICE")) {
            item.price_terms_id = element.price_selected.id;
        }
        lineItems.push(item);
    });
    return lineItems;
}

function getTotalBaseItems(cart) {
    var total = 0;
    cart.forEach(element => {
        total = total + element.totalAmount;
    });
    return total;
}

function groupedByCategory(order_items, allCategories, categorySelected, subCategory) {
    var items = order_items.reduce((acc, curr) => {
        var categories = curr.categories ? curr.categories : [];
        for (let i = 0; i < categories.length; i++) {
            let category = categories[i];
            if ((subCategory && category.id === subCategory) || !subCategory || subCategory == 'All') {
                var isExist = checkCategoryIsExist(category, allCategories, categorySelected);
                if (isExist) {
                    const itemExists = acc.find(item => category && category.id === item.category_id)
                    if (itemExists) {
                        itemExists.products.push(curr);
                    } else {
                        acc.push({ category_id: category.id, category_name: category.name, products: [curr] })
                    }
                }
            }
        }
        return acc;
    }, []);
    return items;
}

function checkCategoryIsExist(category, allCategories, categorySelected) {
    var isExist = false;
    if (allCategories.length > 0) {
        var cat = allCategories.filter(c => {
            if (categorySelected)
                return c.id == category.id && c.parent && c.parent.id === categorySelected.id;
            else
                return c.id == category.id
        })
        if (cat && cat.length > 0) {
            isExist = true;
        }
    }
    return isExist;
}

function getDeliveryItem(items) {
    var deleveryItem = null;
    if (items && items.length > 0) {
        var item = items.filter(line => {
            return line.product.name && line.product.name.toLowerCase().includes('delivery')
        })
        if (item && item.length > 0) {
            deleveryItem = item[0];
        }
    }
    return deleveryItem;
}

function covertListToString(list, key) {
    var componentStr = '';
    list.forEach(item => {
        componentStr = componentStr + item[key] + ", ";
    });
    if (componentStr) {
        componentStr = componentStr.substr(0, componentStr.length - 2);
    }
    return componentStr;
}

function getProductPrice(pricing) {
    if (pricing && pricing.length > 0) {
        pricing = pricing.sort(sortPrice);
    }
    var amount = 0;
    if (pricing && pricing.length > 0) {
        amount = pricing[0].price;
    }
    return amount;
}
function getBillingPeriod(pricing) {
    if (pricing && pricing.length > 0) {
        pricing = pricing.sort(sortPrice);
    }
    var billing_period={};
    if (pricing && pricing.length > 0) {
        billing_period.duration = pricing[0].price_terms && pricing[0].price_terms[0].billing_period ? pricing[0].price_terms[0].billing_period.duration : null ;
        billing_period.uot = pricing[0].price_terms && pricing[0].price_terms[0].billing_period ? pricing[0].price_terms[0].billing_period.uot : null ;
    }
    return billing_period;
}

export function getProductPricePrimary(pricing) {
    let pricePrimary = null;
    if (pricing && pricing.length > 0) {
        pricing = pricing.sort(sortPrice);
    }
    if (pricing && pricing.length > 0) {
        pricePrimary = pricing[0];
    }
    return pricePrimary;
}
function sortPrice(n1, n2) {
    if (n1.price > n2.price) {
        return 1;
    } else if (n1.price < n2.price) {
        return -1
    } else {
        return 0;
    }
}
function validateFulfilment(fulfilled_by) {
    var acceptToChangeFulfilled = false;
    if (fulfilled_by.length === 1) {
        acceptToChangeFulfilled = false;
    } else {
        // return true;
        //disable temporarily as Sozos requested on 02/09/2020 to be able to test iPham
        var isNoParentOrg = false;
        fulfilled_by.forEach(element => {
            if (!element.parent_organisation) {
                isNoParentOrg = true;
            }
        });
        if (isNoParentOrg) {
            acceptToChangeFulfilled = true;
        } else {
            acceptToChangeFulfilled = false;
        }
    }
    console.log("AAAAAAAAAAAAA acceptToChangeFulfilled:", acceptToChangeFulfilled);
    return acceptToChangeFulfilled;
}

function getTotalCartQuantity(carts) {
    var total = 0;
    carts.forEach(cart => {
        total = total + cart.quantity
    });
    return total;
}

function validateComponents(components, componentsSelected) {
    var componentRequireSelected = [];
    for (let i = 0; i < components.length; i++) {
        var component = components[i];
        var minimum = component.minimum_quantity;
        if (minimum > 0) {
            var selected = componentsSelected.filter(c => {
                return c.id === component.id
            })
            if (selected.length == 0) {
                componentRequireSelected.push(component);
            }
        }
    }
    return componentRequireSelected;
}

function filterContactPreferencesByType(data, type) {
    var filterData = [];
    if (data && data.length > 0) {
        filterData = data.filter(item => {
            return item.type == type;
        })
    }
    if (filterData.length > 0) {
        return filterData[0]
    }
    return null;
}

function checkAllowPaymentMethod(type, methods_allow) {
    var isAllow = false;
    if (methods_allow && methods_allow.length > 0) {
        methods_allow.forEach(element => {
            if (element.payment_method_type && element.payment_method_type == type) {
                isAllow = true;
            }
        });
    }
    return isAllow;
}

async function checkAllowOrderByContact(agreement_countries) {
    try {
        console.log("checkAllowOrderByContact agreement_countries:", agreement_countries);
        var result = await crmservices.contacts.getContact();
        console.log("checkAllowOrderByContact getContact result:", result);
        if (result.code == 'OK') {
            var contact = result.data;
            if (contact.country_agreement) {
                console.log("contact.country_agreement:", contact.country_agreement);
                if (agreement_countries.length == 0) {
                    return false;
                } else {
                    var countrySupport = agreement_countries.filter(e => {
                        return e.country == contact.country_agreement;
                    })
                    if (countrySupport && countrySupport.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
        }
    } catch (error) {
        return false;
    }
}

function groupedVariantByAttributes(variants) {
    var items = variants.reduce((acc, curr) => {
        var variant_attributes = curr.variant_attributes ? curr.variant_attributes : [];
        for (var i = 0; i < variant_attributes.length; i++) {
            var attributes = { ...variant_attributes[i] };
            const itemExists = acc.find(item => attributes.key == item.key)
            if (itemExists) {
                const variantExit = itemExists.variations.find(item => item.value == variant_attributes[i].value)
                if (!variantExit || variantExit.length == 0) {
                    var variant = { value: variant_attributes[i].value, ...createVariantObject(curr) };
                    itemExists.variations.push(variant);
                }
            } else {
                var variant = { value: variant_attributes[i].value, ...createVariantObject(curr) }
                acc.push({ key: variant_attributes[i].key, label: variant_attributes[i].label, variations: [variant] })
            }
        }
        return acc;
    }, []);
    return items;
}

function createVariantObject(variation) {
    var element = {};
    element.composition = variation.composition;
    element.creatives = variation.creatives;
    element.id = variation.id;
    element.pricing = variation.pricing;
    element.price = getProductPrice(variation.pricing);
    element.sku = variation.sku;
    element.type = variation.type;
    return element;
}

function findProductByVariantAttributes(variations, variantSelected) {
    var variants = variations;
    for (var k = 0; k < variantSelected.length; k++) {
        variants = filterVariant(variants, variantSelected[k]);
    }
    return variants;
}

function filterVariant(variants, variantSelected) {
    var filterVariant = [];
    for (var i = 0; i < variants.length; i++) {
        var variation = variants[i];
        var variant_attributes = variation.variant_attributes;
        var isExistAttr = false;
        for (var j = 0; j < variant_attributes.length; j++) {
            if (variantSelected.key == variant_attributes[j].key) {
                if (variantSelected.value == variant_attributes[j].value) {
                    isExistAttr = true;
                } else {
                    isExistAttr = false;
                }
            }
        }
        if (isExistAttr) {
            filterVariant.push(variation);
        }
    }
    return filterVariant
}

function getTotalPerProduct(product, isPortal) {
    if (product) {
        var total = product.price;
        if (isPortal) {
            total = product.cost_before_discount;
        }
        if (product.components) {
            product.components.forEach(element => {
                total = total + element.price;
            });
        }
        if (isPortal) {
            total = total * product.quantity
        }
        return total;
    } return 0;
}
function getTotalAmountItem(product) {
    console.log("product:", product);
    var total = product.cost ? product.cost : 0;
    var quantity = product.quantity ? product.quantity : 0;
    let componentAmount = 0;
    if (product.components) {
        product.components.forEach(element => {
            componentAmount = componentAmount + element.price;
        });
        componentAmount = componentAmount * 2;
    }
    return total + componentAmount;
}
function sortByCardPrimary(n1, n2) {
    if (n1.is_primary)
        return -1;
    else if (n2.is_primary)
        return 1;
    else return 0;
}

function createItemToReorder(item, isPortal) {
    let product = item.product
    let product_key = newGUID();
    var components = product && product.components ? product.components : null;
    var variant_attributes = product && product.variant_attributes ? product.variant_attributes : null;
    var productToBeAdded = {
        id: product.id,
        default_product_id: product.id,
        key: product_key,
        name: product.name,
        description: product.description,
        variant_selected: variant_attributes,
        components: components,
        quantity: product.quantity,
        totalAmount: getTotalPerProduct(product, isPortal),
        price: product.price,
        creatives: product.creatives,
        notes: item.notes ? item.notes : null
    }
    return productToBeAdded;
}

function getOrderSummary(estimate_order_result, isUseWalletFund, request_amount_from_wallet_funds, isValidAmountWalletFund) {
    var invoice_estimate = estimate_order_result ? estimate_order_result.invoice_estimate : null;
    let billing_estimate = estimate_order_result && estimate_order_result.service_delivery_estimate && estimate_order_result.service_delivery_estimate.length > 0 ? estimate_order_result.service_delivery_estimate[0].billing_estimate : null;
    let service_invoice_estimate = billing_estimate && billing_estimate.invoicing && billing_estimate.invoicing.length > 0 ? billing_estimate.invoicing[0] : null;
    // var amountDue = invoice_estimate ? invoice_estimate.amount_due : 0;
    var wallet_funds_amount = invoice_estimate && invoice_estimate.wallet_funds_amount ? invoice_estimate.wallet_funds_amount : 0;
    var wallet_funds_amount_service = service_invoice_estimate && service_invoice_estimate.wallet_funds_amount ? service_invoice_estimate.wallet_funds_amount : 0;
    if (isValidAmountWalletFund && request_amount_from_wallet_funds) {
        wallet_funds_amount = Number(request_amount_from_wallet_funds);
    }
    let subTotal = invoice_estimate ? invoice_estimate.total_price : 0;
    let total_discount_amount = invoice_estimate ? invoice_estimate.total_discount_incl_tax : 0;
    let amountDue = invoice_estimate ? invoice_estimate.amount_due : 0;
    if (service_invoice_estimate) {
        subTotal = subTotal + (service_invoice_estimate.total_price ? service_invoice_estimate.total_price : 0);
        total_discount_amount = total_discount_amount + (service_invoice_estimate.total_discount_incl_tax ? service_invoice_estimate.total_discount_incl_tax : 0)
        amountDue = amountDue + (service_invoice_estimate.amount_due ? service_invoice_estimate.amount_due : 0)
    }
    return {
        subTotalAmount: subTotal,
        wallet_funds_amount: wallet_funds_amount + wallet_funds_amount_service,
        amountDue: amountDue,
        total_discount_amount: total_discount_amount
    }
}


function getProductImageBySize(creatives, size, type) {
    let imageObject = null;
    if (!type) {
        type = usage_type.product_item;
    }
    if (!creatives || creatives.length == 0)
        return null;
    let imageEixstByType = creatives.filter(c => {
        return c.usage_type && c.usage_type.toLowerCase() == type.toLowerCase();
    })
    console.log("imageEixstByType:", imageEixstByType);
    if (!imageEixstByType || imageEixstByType.length == 0) {
        if (type == usage_type.product_item) {
            type = usage_type.product_detail;
        } else {
            type = usage_type.product_item;
        }
        imageEixstByType = creatives.filter(c => {
            return c.usage_type && c.usage_type.toLowerCase() == type.toLowerCase();
        })
    }
    if (imageEixstByType && imageEixstByType.length > 0) {
        let media = imageEixstByType[0].media;
        if (media && media.length > 0) {
            if (size == 'large') {
                imageObject = media[media.length - 1];
                console.log("media.length - 1:", media.length - 1);
            } else {
                imageObject = media[0];
            }
        } else {
            imageObject = imageEixstByType[0];
        }
    }
    return imageObject;
}

function createEsitmateCartItems(estimateResult, localCartsData) {
    let physicalGoodLineItems = estimateResult.invoice_estimate ? estimateResult.invoice_estimate.line_items : [];
    let invalidItems = estimateResult.invalid_products ? estimateResult.invalid_products : [];
    let service_delivery_estimate = estimateResult.service_delivery_estimate && estimateResult.service_delivery_estimate.length > 0 ? estimateResult.service_delivery_estimate[0].billing_estimate : null;
    let serviceLineItems = service_delivery_estimate && service_delivery_estimate.invoicing && service_delivery_estimate.invoicing.length > 0 ? service_delivery_estimate.invoicing[0].line_items : [];
    let cartItems = [];
    console.log('localCartsData===', localCartsData)
    let localCartsDataValid = getCartItemsValid(localCartsData, invalidItems);


    console.log('physicalGoodLineItems===', physicalGoodLineItems)

    let estimateMainPGProducts = getMainProducts(physicalGoodLineItems);
    console.log('estimateMainPGProducts===', estimateMainPGProducts)
    console.log('localCartsDataValid===', localCartsDataValid)
    let estimateMainServices = getMainProducts(serviceLineItems);
    let estimatePGComponents = getComponentsProduct(physicalGoodLineItems);
    let estimateServiceComponents = getComponentsProduct(serviceLineItems);

    localCartsDataValid.forEach(cart => {
        let isService = cart.classification == "TERMED_SERVICE" || cart.classification == "ONE_TIME_SERVICE";
        let products = null;
        if (isService) {
            products = estimateMainServices.filter(p => {
                return p.product.id == cart.id
            })
        } else {
            products = estimateMainPGProducts.filter(p => {
                return p.product.id == cart.id
            })
        }

        console.log("AAAAAAA 111111 products:", products);
        if (products && products.length > 0) {
            let subTotalAmount = products[0].pricing;
            let quantity = products[0].quantity;
            cart = { ...cart, price: subTotalAmount }
        }
        let componentsSelected = [];
        if (cart.components && cart.components.length > 0) {
            cart.components.forEach(component => {
                let components = [];
                if (isService) {
                    components = estimateServiceComponents.filter(c => {
                        return c.product.id == component.id && cart.id == c.bundle_product.id
                    })
                } else {
                    components = estimatePGComponents.filter(c => {
                        return c.product.id == component.id && cart.id == c.bundle_product.id
                    })
                }
                console.log("AAAAAAA 111111 components:", components);
                if (components && components.length > 0) {
                    let subTotalAmount = components[0].pricing;
                    let quantity = components[0].quantity;
                    component = { ...component, price: subTotalAmount };
                }
                componentsSelected.push(component);
            });
            cart.components = componentsSelected;
        }
        cartItems.push(cart);
    });
    return cartItems;
}
function getCartItemsValid(carts, invalid_products){
    let localCartsDataValid = []
    carts.forEach(p => {
        var isValid = true;
        invalid_products.forEach(ip => {
            if (ip.product.id == p.default_product_id) {
                isValid = false;
            }
        });
        if (isValid) {
            localCartsDataValid.push(p);
        }
    })
    return localCartsDataValid;
}
function getMainProducts(estimate_line_items) {
    console.log("AAAAAAA getMainProducts estimate_line_items:", estimate_line_items);
    let products = estimate_line_items.filter(item => {
        return !item.bundle_product;
    })
    return products;
}

function getComponentsProduct(estimate_line_items) {
    console.log("AAAAAAA getComponentsProduct estimate_line_items:", estimate_line_items);
    let products = estimate_line_items.filter(item => {
        return item.bundle_product && item.bundle_product.id;
    })
    return products;
}

function groupServicesByMonth(services) {
    let newService = {};
    if (services.length > 0) {
        services.forEach(element => {
            let service = element.service;
            if (service.price && service.price.billing_period && service.price.billing_period.uot == 'MONTH') {
                let duration = service.price.billing_period.duration;
                let servicePeriod = newService[duration] ? newService[duration] : [];
                servicePeriod.push(element);
                newService[duration] = servicePeriod;
            }
        });
    }
    return newService;
}

function groupServicesByMonthv2(services,currentPeriod) {
    let newService = [];
    if (services && services.length > 0 && currentPeriod) {
        services.forEach(element => {
            let service = element.service;
            let billing_period =  service.price ? service.price.billing_period : null;
            if (billing_period) {
                if(currentPeriod.uot == billing_period.uot && currentPeriod.duration == billing_period.duration){
                    newService.push(element);
                }
            }
        });
    }
    return newService;
}

function groupBillingPeriod(services) {
    let period = [];
    if (services.length > 0) {
        services.forEach(element => {
            let service = element.service;
            if (service.price && service.price.billing_period && service.price.billing_period.uot == 'MONTH') {
                if (service.price.billing_period.duration) {
                    let periodExis = period.filter(p => {
                        return p == service.price.billing_period.duration
                    })
                    if(!periodExis || periodExis.length == 0){
                        period.push(service.price.billing_period.duration)
                    }
                }
            }
        });
    }
    return period;
}

function groupBillingPeriodv2(services) {
    let period = [];
    if (services.length > 0) {
        services.forEach(element => {
            let billing_period = element.service && element.service.price ? element.service.price.billing_period : null;
            if(billing_period){
                let uot = billing_period.uot;
                let duration = billing_period.duration;
                let periodExist = period.filter(p => {
                    return p.uot == uot && p.duration == duration;
                })
                if(!periodExist || periodExist.length == 0){
                    period.push({
                        uot: uot,
                        duration: duration
                    })
                }
            }
        });
    }
    return period;
}

function getRemainingService(services){
    let totalData = 0;
    let totalRemaining = 0;
    services.forEach(service => {
        const products_allowance = service.products_allowance ? service.products_allowance : [];
        let productWifi = products_allowance.filter(p => {
            return p.name.toLowerCase() == "Wifi".toLowerCase();
        })
        if(productWifi && productWifi.length > 0){ 
            totalData = totalData +  (productWifi[0] && productWifi[0].remaining_usage ?  productWifi[0].remaining_usage.per_transaction : 0);
            totalRemaining = totalRemaining +  (productWifi[0] && productWifi[0].remaining_usage ?  productWifi[0].remaining_usage.per_day : 0);
        }
    });
    return ({
        totalData: totalData,
        totalRemaining:totalRemaining
    })
}

function getOfferTypeProgress(item){
    let isShowProgress = item.performance_enabled && item.performance_data && (item.performance_data.type=='PRODUCT' || item.performance_data.type=='AMOUNT') && item.performance_data.percentage_progress ? true : false;
    let isShowEntry = item.performance_enabled && item.performance_data && item.performance_data.type === 'EVENT' && item.performance_data.current_events ? true : false
    return ({
        isShowProgress: isShowProgress,
        isShowEntry: isShowEntry,
        current_entries: item.performance_data ? item.performance_data.current_events : 0,
        percentage_progress: item.performance_data ? item.performance_data.percentage_progress : 0,
    })
}

function compareMerchants(fulfillments, orgNetworks){
    let merchants = [];
    if(fulfillments && fulfillments.length > 0 && orgNetworks && orgNetworks.length > 0){
        for (let i = 0; i < fulfillments.length; i++) {
            const fulfillment = fulfillments[i];
            let existingMerchant = orgNetworks.filter(x => x.id === fulfillment.id);
            if(existingMerchant && existingMerchant.length > 0) merchants.push(fulfillment);
        }
    }
    return merchants;

}

function calculatePriceByRate({quantity,default_price,pricing}){
    console.log("pricing:",pricing);
    console.log("quantity:",quantity);
    let price = default_price * quantity;
    if(pricing && pricing.length > 0){ 
        let mode = pricing[0].rate_model;
        let tiers = pricing[0].tiers
        if(mode=='STAIRSTEP'){
            price = calculateStairstepMode(quantity,tiers);
        }else if(mode=='TIERED'){
            price = calculateTieredMode(quantity,tiers);
        }else if(mode=='VOLUME'){
            price = calculateVolumnMode(quantity,tiers);
        }
    }
    return price;
}

function calculateTieredMode(quantity,tiers){
    let price = 0;
    let index = 0;
    for(let i=0;i<tiers.length;i++){
        let lower_tier = tiers[i].lower_tier;
        let upper_tier = tiers[i].upper_tier;
        if((upper_tier && quantity>=lower_tier && quantity<=upper_tier) || (!upper_tier && quantity>=lower_tier)){
            price = tiers[i].price;
            index = i;
            break;
        }
    }
    console.log("price:",price);
    console.log("index:",index);
    console.log("quantity:",quantity);
    if(index > 0){
        let prevPrice = 0;
        let tierQuantity = quantity;
        for(let j=0;j<index;j++){
            tierQuantity = quantity - tiers[j].upper_tier;
            console.log("tiers[j].upper_tier:",tiers[j].upper_tier);
            let currentTierPrice = tiers[j].price  ? tiers[j].price  : 0;
            let currentTierQuantity = tiers[j].upper_tier ? (tiers[j].upper_tier - tiers[j].lower_tier + 1) : (quantity - tiers[j].lower_tier + 1);
            console.log("currentTierQuantity:",currentTierQuantity);
            prevPrice = prevPrice + (currentTierQuantity * currentTierPrice);
            console.log("prevPrice:",prevPrice);
        }
        console.log("tierQuantity:",tierQuantity);
        if(tierQuantity < 0){
            tierQuantity = 1;
        }
        price = (price * tierQuantity) + prevPrice;
    }else{
        price = price * quantity
    }
    return price;
}

function calculateVolumnMode(quantity,tiers){
    let price = 0;
    for(let i=0;i<tiers.length;i++){
        let lower_tier = tiers[i].lower_tier;
        let upper_tier = tiers[i].upper_tier;
        if((upper_tier && quantity>=lower_tier && quantity<=upper_tier) || (!upper_tier && quantity>=lower_tier)){
            price = tiers[i].price * quantity;
            break;
        }
    }
    return price;
}

function calculateStairstepMode(quantity,tiers){
    let price = 0;
    for(let i=0;i<tiers.length;i++){
        let lower_tier = tiers[i].lower_tier;
        let upper_tier = tiers[i].upper_tier;
        if((upper_tier && quantity>=lower_tier && quantity<=upper_tier) || (!upper_tier && quantity>=lower_tier)){
            price = tiers[i].price;
            break;
        }
    }
    return price;
}

